import React from 'react';
import { Link, graphql } from 'gatsby';
import Layout from '../components/layout';
import Seo from '../components/seo';
import Slider from 'react-slick';

const BlogSingle = ({
  data: {
    contentfulBlogPost,
    allContentfulBlogPost: { edges: allPosts = [] },
  },
}) => (
  <Layout>
    <Seo title="Blog single" />
    <section className="blogSingleHero">
      <div className="blog-page-rectangle">
        <span className="big-gradient-circle" />
        <span className="big-gradient-circle red-gradient" />
        <span className="big-gradient-circle green-gradient" />
        <h1>{contentfulBlogPost?.title}</h1>
        <div style={{ display: 'inline-block' }}>
          <div className="blog-author flex-row align-items-center auto-margin ">
            <img
              src={contentfulBlogPost?.author?.image?.fluid?.src}
              alt=""
              className="author-image"
              style={{
                width: 25,
                height: 25,
                borderRadius: '50%',
                objectFit: 'cover',
              }}
            />
            <h5>
              {contentfulBlogPost?.author?.name},{' '}
              <span>{contentfulBlogPost?.publishedDate}</span>
            </h5>
          </div>
        </div>
      </div>
    </section>
    <section className="blogPage">
      <div className="small-container-blog">
        <img
          src={contentfulBlogPost?.featuredImage?.fluid?.src}
          alt=""
          className="blog-page-image"
        />
        <div className=" blog-page-content-area">
          <div>
            <div className="link-logo">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/clip-hire/">
                <svg
                  width="40"
                  height="40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="20" cy="20" r="20" fill="url(#paint0_linear)" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12.273 13.636a1.818 1.818 0 113.636 0 1.818 1.818 0 01-3.636 0zm15.909 7.646a4.19 4.19 0 00-3.228-4.146 4.054 4.054 0 00-3.59.973v-.382a.455.455 0 00-.455-.454h-2.273a.455.455 0 00-.454.454v9.091c0 .251.203.455.454.455h2.273a.455.455 0 00.454-.455v-5.127a1.882 1.882 0 011.51-1.891A1.818 1.818 0 0125 21.618v5.2c0 .251.203.455.454.455h2.273a.455.455 0 00.455-.455v-5.536zm-12.273-3.555v9.091a.455.455 0 01-.455.455h-2.273a.455.455 0 01-.454-.455v-9.09c0-.252.203-.455.454-.455h2.273c.251 0 .455.203.455.454z"
                    fill="#fff"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="-8.561"
                      y1="11.604"
                      x2="14.648"
                      y2="46.804"
                      gradientUnits="userSpaceOnUse">
                      <stop stopColor="#6C5BF2" />
                      <stop offset="1" stopColor="#8841F9" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/cliphire">
                <svg
                  width="40"
                  height="40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="20" cy="20" r="20" fill="#000" />
                  <path
                    d="M24.09 14.545h-2.727a.91.91 0 00-.909.91v2.727h3.636a.318.318 0 01.31.418l-.673 2a.454.454 0 01-.427.309h-2.846v6.818a.455.455 0 01-.454.455h-2.273a.455.455 0 01-.455-.455V20.91H15.91a.455.455 0 01-.455-.454v-1.819c0-.25.204-.454.455-.454h1.363v-2.727a3.636 3.636 0 013.637-3.637h3.181c.252 0 .455.204.455.455v1.818a.455.455 0 01-.455.454z"
                    fill="#fff"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="-8.561"
                      y1="11.604"
                      x2="14.648"
                      y2="46.804"
                      gradientUnits="userSpaceOnUse">
                      <stop stopColor="#6C5BF2" />
                      <stop offset="1" stopColor="#8841F9" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/Clip_Hire">
                <svg
                  width="40"
                  height="40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="20" cy="20" r="20" fill="#000" />
                  <path
                    d="M29.09 14.954a7.27 7.27 0 01-1.681 1.619v.5a11.09 11.09 0 01-11.245 11.109 11.127 11.127 0 01-4.955-1.146.227.227 0 01-.136-.209v-.1c0-.13.105-.236.236-.236a8.054 8.054 0 004.655-1.673 3.973 3.973 0 01-3.537-2.327.236.236 0 01.237-.327c.464.046.933.003 1.381-.128a3.964 3.964 0 01-3.136-3.463.236.236 0 01.327-.237c.453.2.942.305 1.437.31a3.89 3.89 0 01-1.555-4.492.491.491 0 01.827-.163 11.236 11.236 0 007.646 3.527 3.636 3.636 0 01-.11-.909 3.964 3.964 0 016.828-2.673 7.9 7.9 0 002.173-.754.154.154 0 01.163 0 .155.155 0 010 .163 3.973 3.973 0 01-1.6 1.819 7.796 7.796 0 001.818-.437.145.145 0 01.164 0 .155.155 0 01.064.227z"
                    fill="#fff"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="-8.561"
                      y1="11.604"
                      x2="14.648"
                      y2="46.804"
                      gradientUnits="userSpaceOnUse">
                      <stop stopColor="#6C5BF2" />
                      <stop offset="1" stopColor="#8841F9" />
                    </linearGradient>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
          <div
            className="blog-page-content"
            dangerouslySetInnerHTML={{
              __html: contentfulBlogPost?.content?.childMarkdownRemark?.html,
            }}
          />
        </div>
      </div>
      <div className="blog-endpage-rectangle">
        <span className="red-oval-gradient" />
        <span className="green-oval-gradient" />
        <span className="purple-oval-gradient" />
        <h3>Ready to job-search smarter? We make it easy.</h3>
        <Link to="/" className="button">
          Get Started for Free
        </Link>
      </div>
    </section>

    <section className="blog-single-slider-main">
      <div className="container">
        <h2 className="heading">Similar Blogs</h2>
      </div>
      <div className="blogList">
        <Slider
          className="center"
          arrows
          centerMode
          infinite
          centerPadding="200px"
          slidesToShow={5}
          speed={500}
          responsive={[
            {
              breakpoint: 2600,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 1600,
              settings: {
                centerPadding: '150px',
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 990,
              settings: {
                centerPadding: '0',
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 767,
              settings: {
                centerPadding: '0',
                slidesToShow: 1,
              },
            },
          ]}>
          {allPosts.map(({ node }, i) => (
            <div className="item">
              <React.Fragment key={i}>
                {
                  <div className="blog-single-slider">
                    <Link to={`/blog/${node?.slug}`}>
                      <div className="blog-container">
                        <div className="blog-image-wrapper">
                          <img
                            src={node?.featuredImage?.fluid?.src}
                            alt=""
                            className="blog-image"
                          />
                        </div>
                        <div className="blog-author flex-row no-margin align-items-center">
                          <img
                            src={node?.author?.image?.fluid?.src}
                            alt=""
                            className="author-image"
                            style={{
                              width: 25,
                              height: 25,
                              borderRadius: '50%',
                              objectFit: 'cover',
                            }}
                          />
                          <h5>
                            {node?.author?.name},{' '}
                            <span>{node?.publishedDate}</span>
                          </h5>
                        </div>
                        <h4>{node?.title}</h4>
                        <p>{node?.excerpt?.excerpt}</p>
                      </div>
                    </Link>
                  </div>
                }
              </React.Fragment>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  </Layout>
);

export default BlogSingle;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    allContentfulBlogPost(sort: { fields: publishedDate, order: DESC }) {
      edges {
        node {
          title
          id
          slug
          publishedDate(formatString: "MMMM Do, YYYY")
          excerpt {
            excerpt
          }
          featuredImage {
            fluid {
              src
            }
          }
          author {
            name
            image {
              fluid {
                src
              }
            }
          }
        }
      }
    }
    site {
      siteMetadata {
        title
      }
    }
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      slug
      excerpt {
        excerpt
      }
      publishedDate(formatString: "MMMM Do, YYYY")
      featuredImage {
        fluid {
          src
        }
      }
      author {
        name
        image {
          fluid {
            src
          }
        }
      }
      content {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;
